<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-row fluid justify="center">
        <v-radio-group v-model="print_type" row>
          <v-radio label="Print Bulk Icards" value="Bulk"></v-radio>
          <v-radio label="Print Specific Icards" value="Specific"></v-radio>
        </v-radio-group>
      </v-row>
      <template v-if="print_type == 'Bulk'">
        <v-row justify="center">
          <v-col cols="12" sm="5" md="5">
            <v-select v-model="sel_emp" :items="inst_list" item-text="name" item-value="instid" hint="Select Employees"
              label="Employee List" multiple dense autocomplete outlined clearable @change="selectAllEmployees"
              persistent-hint></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-btn color="primary" @click="bulk">Proceed to bulk <span class="i-card"> Icard </span> print</v-btn>
          </v-col>
          <v-col cols="12" sm="3" md="3" style="margin-left: -40px;">
            <v-btn color="primary" @click="getRemainingEmployeeData()">Get Incomplete Employee List</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-if="print_type == 'Specific'">
        <br />
        <v-row justify="center" dense>
          <v-col sm="5">
            <v-textarea v-model="emp_code" color="#0F2027" rounded dense label="Enter Comma Seperated Employee Code"
              outlined></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="3" v-if="emp_code">
            <v-btn color="primary" @click="getSpecificInstructor()">Proceed To <span class="i-card"> Icard </span>
              print</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card>
    <v-card class="box" v-if="icard_data_rem_employees.length != '' && print_type != 'Specific'">

      <v-data-table :headers="headers" :items="icard_data_rem_employees" dense class="elevation-1 mytable" id="mytable"
        :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Employees</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field style="color: black; background-color: white;" v-model="search" append-icon="search"
              label="Search" single-line hide-details></v-text-field>
            <v-btn v-if="icard_data_rem_students != ''" class="ma-2 no-display" rounded color="white" outlined small
              @click="fnExcelReport('mytable', 'Incomplete Employee data')" :loading="loader"><v-icon
                color="white">mdi-export</v-icon>Export</v-btn>
          </v-toolbar>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    barcode: VueBarcode,

    Breadcrumbs,

  },
  data: () => ({
    print_type: null,
    comp_load: false,
    inst_list: [],
    radios: null,
    snackbar_msg: "",
    snackbar: false,
    inst_data: null,
    icard_data: [],
    barcodeValue: "test",
    isEnabled: false,
    emp_code: "",
    for: null,
    usertype: null,
    sel_emp: [],
    color: "",
    selectedAll: false,
    tenant: null,
    icard_data_rem_employees: [],
    search: "",
    headers: [
      {
        text: "Employee",
        align: "left",
        sortable: false,
        value: "grno",
      },
      {
        text: "Data Remaining",
        align: "left",
        sortable: false,
        value: "icard_fields_remaining",
      },
    ],
  }),

  mounted() {
    this.tenant = localStorage.getItem("EPS-tenant")
    this.comp_load = true;
    this.inst_data = null;
    axios
      .post("/RoleManagement/getAllEmployee")
      .then((res) => {
        if (res.data.msg == "200") {
          this.inst_list = res.data.inst_list;
          this.inst_list.unshift({ name: "All", instid: "all" });
        } else {
          alert("Somthing went wrong!!!");
        }
      })
      .catch((error) => {
        alert("Somthing went wrong!!!");
      })
      .finally(() => {
        this.comp_load = false;
      });
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table style='border-collapse:collapse;' border='1'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      exportTable.find(".v-toolbar").remove();
      exportTable.find('th, td').each(function () {
        $(this).css('border', '1px solid black');
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name + '.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    selectAllEmployees(selected) {
      if (selected.includes("all")) {
        this.sel_emp = this.inst_list.map((emp) => emp.instid); //will check checkboxes
        this.selectedAll = true;
        console.log(
          "selected " +
          selected.length +
          " inst " +
          this.inst_list.length +
          " sel_imp " +
          this.sel_emp.length
        );
        if (selected.length == this.sel_emp.length - 1) {
          this.sel_emp = selected;
          this.sel_emp = this.sel_emp.filter((id) => id != "all");
          this.selectedAll = false;
        }
      }
      if (
        selected.length == this.inst_list.length - 1 &&
        !selected.includes("all") &&
        this.selectedAll
      ) {
        this.sel_emp = [];
        this.selectedAll = false;
      } else if (
        selected.length == this.inst_list.length - 1 &&
        !selected.includes("all")
      ) {
        this.sel_emp.push("all");
        this.selectedAll = true;
      }
    },
    bulk() {
      const data = {
        for: "bulk",
        usertype: "Employee",
        employees: this.sel_emp.filter((id) => id !== "all"),
      };
      this.overlay = true;
      if (this.sel_emp.length == 0) {
        this.showSnackbar("red", "Please Select Employee(s) !!!");
        return;
      }
      axios
        .post("/Icard/generateIcardCommon", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.inst_data = res.data.inst_data;
            this.common_data = res.data.common_data;
            localStorage.setItem("icard_data", JSON.stringify(this.icard_data));
            localStorage.setItem("inst_data", JSON.stringify(this.inst_data));
            localStorage.setItem("common_data", JSON.stringify(this.common_data));
            if (this.tenant == 'tmvidyalaya') {
              let routeData = this.$router.resolve({
                name: "tmv-inst-card-print",
              });
              window.open(routeData.href, "_blank");
            } else {
              let routeData = this.$router.resolve({
                name: "inst-card-print",
              });
              window.open(routeData.href, "_blank");
            }
          } else {
            alert(res.data.snackbar);
          }
          this.overlay = false;
        })

        .catch((error) => {
          console.log("Error", error);
          alert("Somthing went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    getRemainingEmployeeData() {
      this.icard_data_rem_employees = [];
      axios
        .post("/icard/getIcardIncompleteEmployee", {})
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data_rem_employees = res.data.icard_data;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          alert("Something went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    getSpecificInstructor() {
      const data = {
        inst_data: this.emp_code,
        for: "specific",
        usertype: "Employee",
      };
      axios
        .post("/Icard/generateIcardCommon", data)
        .then((res) => {
          this.icard_data = res.data.icard_data;
          this.common_data = res.data.common_data;
          localStorage.setItem("icard_data", JSON.stringify(this.icard_data));
          localStorage.setItem("inst_data", JSON.stringify(this.inst_data));
          localStorage.setItem("common_data", JSON.stringify(this.common_data));
          if (this.tenant == 'tmvidyalaya') {
            let routeData = this.$router.resolve({
              name: "tmv-inst-card-print",
            });
            window.open(routeData.href, "_blank");
          } else {
            let routeData = this.$router.resolve({
              name: "inst-card-print",
            });
            window.open(routeData.href, "_blank");
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    changeAuth() {
      this.authority = "Director";
      this.icard_data[0].sign = this.authority_sign;
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
wrap {
  align-self: flex-end;
}

h2 {
  font-size: 1.2em;
}

tr,
td {
  width: 100%;
}

.i-card {
  color: greenyellow;
  font-size: medium;
  margin-left: 2px;
  margin-right: 2px;
}

@media print {
  .pagebreak {
    page-break-before: always;
  }

  header,
  footer,
  nav,
  date {
    display: none !important;
    margin-top: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
    margin-top: none !important;
  }

  v-card {
    border: none !important;
    margin-top: none !important;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  @page {
    size: A4;
    margin-top: none !important;
    padding-top: none !important;
    size: 15.5in 15.5in;
  }
}
</style>
